<div class="col-md-12">
    <h4>Details</h4>
    <ul>
        <li class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Name: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{ userCycle.LastName }}, {{ userCycle.FirstName }}
            </div>
        </li>
        <li class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Status: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{ complianceItemHelpersService.userStatusToString(userCycle.UserStatus) }}
            </div>
        </li>
        <li class="row mb-2 approvers-section" *ngIf="complianceItemHelpersService.isPendingApproval(userCycle.UserStatus)">
            <div class="col-md-12 col-lg-4">
                <strong>Approver: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{ userCycle.PendingStatus }}
            </div>
        </li>
        <li class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Start Date: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                <span>{{ userCycle.StartDate | dateExtended: 'MM/dd/yyyy' }}</span>
            </div>
        </li>
        <li class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>End Date: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                <span>{{ userCycle.EndDate | dateExtended: 'MM/dd/yyyy' }}</span>
            </div>
        </li>
    </ul>
</div>
<br />
<div class="col-md-12">
    <h4>History</h4>
    <ul class="history-item">
        <li *ngFor="let _historyItem of verificationHistory">
            <user-cycle-history-item
                [historyItem]="_historyItem"
                (onMessagesClicked)="onMessagesClicked()">
            </user-cycle-history-item>
        </li>
    </ul>
</div>